import React, { Component } from 'react';
import { Manager, Reference, Popper } from 'react-popper';

import BodyPortal from '../portals/body-portal';

const popperModifiers = {
    preventOverflow: {
        boundariesElement: 'window',
        padding: 20
    }
};

export default class Tooltip extends Component {
    static defaultProps = {
        className: '',
        showDelay: 0,
        withTooltipHover: true
    }

    constructor(props) {
        super(props);

        this.state = {
            visible: props.visible
        };

        this.tooltipHovered = false;
        this.refMouseLeaveTimeout = null;
        this.refHovered = false;
        this.popperUpdate = null;
    }

    handleTooltipClick = event => {
        if (event.target.classList.contains('close-tooltips')) {
            this.hide();
        }
    }

    handleRefElementMouseEnter = () => {
        if (this.props.disabled) {
            return;
        }

        if (this.tooltipMouseLeaveTimeout) {
            clearTimeout(this.tooltipMouseLeaveTimeout);
        }

        this.refHovered = true;

        this.show();
    };

    handleRefElementMouseLeave = () => {
        if (this.props.disabled) {
            return;
        }

        this.refHovered = false;

        if (this.tooltipHovered) {
            return;
        }

        if (this.refMouseLeaveTimeout) {
            clearTimeout(this.refMouseLeaveTimeout);
        }

        if (this.showTimeout) {
            this.hide();
        }

        this.refMouseLeaveTimeout = setTimeout(() => {
            this.refMouseLeaveTimeout = null;


            this.hide();
        }, 50);
    }

    handleTooltipMouseEnter = () => {
        if (!this.props.withTooltipHover) {
            return;
        }

        if (this.refMouseLeaveTimeout) {
            clearTimeout(this.refMouseLeaveTimeout);
        }

        this.tooltipHovered = true;

        this.show();
    }

    handleTooltipMouseLeave = () => {
        if (!this.props.withTooltipHover) {
            return;
        }

        this.tooltipHovered = false;

        if (this.refHovered) {
            return;
        }

        if (this.tooltipMouseLeaveTimeout) {
            clearTimeout(this.tooltipMouseLeaveTimeout);
        }

        this.tooltipMouseLeaveTimeout = setTimeout(() => {
            this.tooltipMouseLeaveTimeout = null;

            this.hide();
        }, 50);
    }

    handleRefElementClick = () => {
        if (this.props.preventHideOnClick) {
            return;
        }

        this.hide();
    }

    show(showDelay = this.props.showDelay) {
        if (this.state.visible) {
            return;
        }

        if (this.tooltipMouseLeaveTimeout) {
            clearTimeout(this.tooltipMouseLeaveTimeout);
        }

        if (this.showTimeout) {
            return;
        }

        this.showTimeout = setTimeout(() => {
            this.showTimeout = null;

            this.setState({
                visible: true
            }, () => this.popperUpdate());

            this.props.onShow && this.props.onShow();
        }, showDelay);

    }

    hide() {
        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
            this.showTimeout = null;
        }

        if (!this.state.visible) {
            return;
        }

        if (this.tooltipMouseLeaveTimeout) {
            clearTimeout(this.tooltipMouseLeaveTimeout);
        }

        this.setState({
            visible: false
        });

        this.props.onHide && this.props.onHide();
    }

    componentWillUnmount() {
        this.hide();

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController(null);
            }
        }

        this.refMouseLeaveTimeout && clearTimeout(this.refMouseLeaveTimeout);
        this.tooltipMouseLeaveTimeout && clearTimeout(this.tooltipMouseLeaveTimeout);
        this.showTimeout && clearTimeout(this.showTimeout);
    }

    componentDidMount() {
        const ctrl = {
            show: showDelay => {
                this.show(showDelay);
            },
            hide: () => {
                this.hide();
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentDidUpdate(prevProps) {
        this.popperUpdate && this.popperUpdate();

        if (this.props.disabled && !prevProps.disabled) {
            this.hide();
        }
    }

    render() {
        return (
            <Manager>
                <Reference>
                    {
                        ({ ref }) => React.cloneElement(this.props.children, {
                            ref,
                            onMouseEnter: this.handleRefElementMouseEnter,
                            onMouseLeave: this.handleRefElementMouseLeave,
                            onMouseDown: this.handleRefElementClick
                        })
                    }
                </Reference>

                {
                    this.state.visible ? (
                        <BodyPortal>
                            <Popper
                                placement={this.props.placement}
                                modifiers={popperModifiers}
                            >
                                {({ placement, ref, style, arrowProps, scheduleUpdate }) => {
                                    this.popperUpdate = scheduleUpdate;

                                    return (
                                        <div
                                            ref={ref}
                                            style={style}
                                            data-placement={placement}
                                            className={'overlay-ui-element ' + (this.props.type === 'popout' ? 'popout ' : 'tooltip ') + this.props.className + (this.state.visible ? ' visible' : '')}
                                            onMouseEnter={this.handleTooltipMouseEnter}
                                            onMouseLeave={this.handleTooltipMouseLeave}
                                            onClick={this.handleTooltipClick}
                                        >
                                            {this.props.tooltip}
            
                                            <span className="overlay-ui-element-arrow" ref={arrowProps.ref} style={arrowProps.style} />
                                        </div>
                                    )
                                }}
                            </Popper>
                        </BodyPortal>
                    ) : null
                }
            </Manager>
        );
    }
}
